import type { InputHTMLAttributes } from 'react';

import { EyeIcon, EyeInvisibleIcon } from './AuthIcons';

interface PasswordToggleInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id'> {
  id: string;
  show: boolean;
  onToggleShow: () => void;
  showLabel: string;
  hideLabel: string;
}

/**
 * `.input-icon`/`.input-icon-btn` password field with a show/hide toggle —
 * the in-app-form counterpart to AuthField.tsx's `AuthPasswordField` (that
 * one skins the pre-login auth-split screens; this one matches ordinary
 * dashboard fields). Used by every password input on the change-password
 * form so the toggle's markup and a11y wiring live in one place instead of
 * being copy-pasted per field.
 */
export function PasswordToggleInput({
  id,
  show,
  onToggleShow,
  showLabel,
  hideLabel,
  className,
  ...inputProps
}: PasswordToggleInputProps) {
  return (
    <div className="input-icon">
      <input
        id={id}
        type={show ? 'text' : 'password'}
        className={['has-toggle', className].filter(Boolean).join(' ')}
        {...inputProps}
      />
      <button type="button" className="input-icon-btn" aria-label={show ? hideLabel : showLabel} onClick={onToggleShow}>
        {show ? <EyeInvisibleIcon /> : <EyeIcon />}
      </button>
    </div>
  );
}
